<template>
  <div>
    <small>{{ description }}</small> <br>
    <b-button v-b-modal="'' + dynamicName" class="btn btn-sm">{{
      title
    }}</b-button>

    <b-modal
     :id="dynamicName" 
     :title="title" 
     :ref="dynamicName"
      ok-variant="primary"
      cancel-variant="secondary"
      cancel-title="Anuluj"
      ok-title="Zapisz"
      @ok ="onSubmit()">
      <b-form @submit="onSubmit">
        <b-form-group
          :id="dynamicName"
          label="Nazwa"
          label-for="new-raw-material"
        >
          <b-form-input
            :id="'new-item_' + dynamicName"
            v-model="name"
            type="text"
            required
            placeholder="Podaj nazwę"
          ></b-form-input>
        </b-form-group>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import toastrMixin from "../../mixins/toastr";

export default {
  name: "QuickAdd",
  data() {
    return {
      name: "",
      dynamicName: "modal" + this._uid,
    };
  },
  mixins: [toastrMixin],
  methods: {
    onSubmit() {
      this.$store.dispatch(this.dispatchName, this.name);
      this.$bvModal.hide(this.dynamicName);
    },
  },
  props: ["dispatchName", "title", "description"],
};
</script>